const campaignTypes = [
  {
    icon: 'credit_card',
    title: 'Fundraise',
    value: 'OF-Fundraising',
    selectable: true,
    margin: 0
  },
  {
    icon: 'person_add',
    title: 'Recruit volunteers',
    value: 'OF-Volunteers',
    selectable: true,
    margin: 0
  },
  {
    icon: 'record_voice_over',
    title: 'Reach out to voters',
    subbullets: [
      // {
      //   title: 'Primary',
      //   value: 'OF-Primary',
      //   selectable: true,
      //   margin: 2.5
      // },
      {
        title: 'General election',
        value: 'OF-General',
        selectable: true,
        margin: 2.5
      }, {
        title: 'GOTV',
        value: 'OF-GOTV',
        selectable: true,
        margin: 2.5
      }
    ],
    selectable: false,
    margin: 0
  },
  {
    icon: 'event',
    title: 'Promote an event',
    value: 'OF-Events',
    selectable: true,
    margin: 0
  }
]

export default campaignTypes
